import { SerializedError } from '@reduxjs/toolkit'

import { Bank } from './Bank'

export type BankAccountsStatus = 'idle' | 'loading' | 'succeed' | 'failed'

export interface BankWithAccountsState {
  bank: Bank
  status: BankAccountsStatus
  error: SerializedError
}
